import {
  forwardRef,
  InputHTMLAttributes,
  memo,
  ReactNode,
  Ref,
} from 'react';

import styled from '@emotion/styled';

import COLOR from '../../constant/colorset';

import CheckboxIcon from './CheckboxIcon';
import CheckboxFlatIcon from './CheckboxFlatIcon';

const Label = styled.label(({ withLabel, disabled, isFullSize }: {
  withLabel: boolean;
  disabled: boolean;
  isFullSize: boolean;
}) => (withLabel ? `
  padding: 14px 0 9px;
  position: relative;
  display: ${isFullSize ? 'flex' : 'inline-flex'};
  align-items: center;
  font-size: 16px;
  vertical-align: top;
  line-height: normal;
  color: ${disabled ? COLOR.lightGray : COLOR.kurlyGray800};
` : ''));

const Input = styled.input`
  overflow: hidden;
  position: absolute;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  width: 1px;
  height: 1px;
`;

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string | ReactNode;
  isFullSize?: boolean;
  theme?: 'flat' | 'basic';
  testId?: string;
}

function Checkbox({
  className,
  id,
  label,
  isFullSize = true,
  disabled = false,
  checked = false,
  theme = 'basic',
  ...props
}: Props, ref: Ref<HTMLInputElement>) {
  return (
    <Label
      className={className}
      htmlFor={id}
      disabled={disabled}
      isFullSize={isFullSize}
      withLabel={!!label}
    >
      <Input
        {...props}
        id={id}
        ref={ref}
        disabled={disabled}
        checked={checked}
        type="checkbox"
      />
      {theme === 'basic' ? (
        <CheckboxIcon
          disabled={disabled}
          checked={checked}
        />
      ) : (
        <CheckboxFlatIcon
          disabled={disabled}
          checked={checked}
        />
      )}
      {label}
    </Label>
  );
}

export default memo(forwardRef(Checkbox));
